import type { FunctionComponent } from 'react';

import styles from './styles.less';

const SelectGroup: FunctionComponent<React.PropsWithChildren<unknown>> = (props) => (
  <div className={styles['select-group']}>{props.children}</div>
);

export default SelectGroup;
